import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Building2, Check, Star, StarOff } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const AccountSwitcher: React.FC = () => {
  const { user, availableClients, defaultClientId, switchClient, clearDefaultClient } = useAuth();

  // Só aparece para usuários com mais de uma conta vinculada.
  if (!availableClients || availableClients.length <= 1) return null;

  const ativo = availableClients.find((c) => c.id === user?.client_id);
  const nomeAtivo = ativo?.trade_name || ativo?.legal_name || 'Selecionar conta';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-9 gap-2 rounded-md hover:bg-muted/80 max-w-[200px]" title="Trocar de conta">
          <Building2 className="h-4 w-4 text-foreground flex-shrink-0" />
          <span className="text-sm font-medium truncate">{nomeAtivo}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Suas contas</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {availableClients.map((c) => {
          const isAtivo = c.id === user?.client_id;
          const isPadrao = c.id === defaultClientId;
          return (
            <DropdownMenuItem
              key={c.id}
              onClick={() => { if (!isAtivo) switchClient(c.id); }}
              className="flex items-center justify-between gap-2"
            >
              <span className="truncate">
                {c.trade_name || c.legal_name}
                {isPadrao && <span className="ml-1 text-xs text-muted-foreground">(padrão)</span>}
              </span>
              {isAtivo && <Check className="h-4 w-4 text-primary flex-shrink-0" />}
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        {defaultClientId === user?.client_id ? (
          <DropdownMenuItem onClick={() => clearDefaultClient()} className="gap-2">
            <StarOff className="h-4 w-4" /> Não abrir sempre nesta conta
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={() => user?.client_id && switchClient(user.client_id, true)} className="gap-2">
            <Star className="h-4 w-4" /> Definir conta atual como padrão
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AccountSwitcher;
